module.exports = __webpack_public_path__ + "badfac55472200e1544a48ca4dc8e0c9.png";